import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import Modal from 'tg-modal';

import ConfirmModal from 'components/ConfirmModal';
import {
    workLogAction,
    workLogAddProduct,
    workLogAddWorker,
    workLogStart,
    workLogGroupStopOneProduct,
} from 'ducks/workLogs';
import {gettext} from 'utils/text';
import api from 'utils/api';
import {ORDERS} from 'constants/sales';


const StopConfirmationModal = (
    {isOpen, onCancel, onConfirmAll, onConfirmOne},
) => (
    <Modal
        isOpen={isOpen}
        onCancel={onCancel}
        onConfirm={onConfirmAll}
        title={gettext('Confirmation')}
        dialogClassName="tg-modal-dialog stop-confirmation-modal"
    >
        <div className="tg-modal-body pt-0 pl-4">
            {gettext('Would you like to stop work on all products in the work log or just this one?')}
        </div>
        <div className="modal-footer">
            <button
                className="btn btn-secondary btn-lg mr-3"
                onClick={onCancel}
            >
                {gettext('Cancel')}
            </button>
            <button
                className="btn btn-secondary btn-lg"
                onClick={onConfirmOne}
            >
                {gettext('Only this')}
            </button>
            <button
                className="btn btn-primary btn-lg"
                onClick={onConfirmAll}
            >
                {gettext('All')}
            </button>
        </div>
    </Modal>
);

StopConfirmationModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onConfirmAll: PropTypes.func.isRequired,
    onConfirmOne: PropTypes.func.isRequired,
};


class ProductTimerButtons extends React.Component {

    static propTypes = {
        userId: PropTypes.number.isRequired,
        productId: PropTypes.number.isRequired,
        showAddWorker: PropTypes.bool.isRequired,
        workLogsLoading: PropTypes.bool.isRequired,
        workLogsError: PropTypes.string,
        activeWorkLogGroups: PropTypes.arrayOf(PropTypes.shape({
            operation: PropTypes.string.isRequired,
        })).isRequired,
        workLogGroups: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number,
            start_time: PropTypes.string,
            end_time: PropTypes.string,
            work_logs: PropTypes.arrayOf(PropTypes.shape({
                user: PropTypes.shape({
                    id: PropTypes.number,
                    name: PropTypes.string,
                }),
                product: PropTypes.number,
            })),
        })),
        workers: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
        })).isRequired,
        workLogAction: PropTypes.func.isRequired,
        workLogAddProduct: PropTypes.func.isRequired,
        workLogAddWorker: PropTypes.func.isRequired,
        workLogStart: PropTypes.func.isRequired,
        workLogGroupStopOneProduct: PropTypes.func.isRequired,
        isListLayout: PropTypes.bool,
        inProgressForCurrentUser: PropTypes.bool,
    };

    static defaultProps = {
        workLogsError: null,
        isListLayout: false,
        workLogGroups: [],
        inProgressForCurrentUser: false,
    };

    state = {
        confirmModal: null,
        InProgressByOtherUser: false,
    };

    getActiveWorkLog = activeGroups => activeGroups.find(g => g.end_time === null);

    getButtonClasses = (isListLayout, theme) => {
        const base = `card bg-${theme} btn btn-${theme} justify-content-center px-4`;
        if (isListLayout) {
            return `${base} flex-no-grow-fit`;
        }
        return `${base} py-3 align-items-center`;
    };

    getIconSize = () => (this.props.isListLayout ? "3x" : "2x");

    hideModal = () => {
        this.setState({confirmModal: null});
    };

    hideStopConfirmModal = () => {
        this.setState({stopConfirmModal: null});
    };

    isProductWorkLogGroup = (workLogGroup, productId) =>
        workLogGroup.work_logs.filter(wl => wl.product === productId).length > 0;

    handleButton = (e) => {
        e.preventDefault();
        return !this.props.workLogsLoading;
    };

    handleActionButton = (e, workLogGroupId, action, description) => {
        if (this.handleButton(e)) {
            this.setState({
                confirmModal: {
                    action,
                    description,
                    onConfirm: () =>
                        this.props.workLogAction(
                        workLogGroupId, action, this.props.productId, this.props.userId, !this.props.isListLayout,
                    ),
                },
            });
        }
    };

    handleAddProductButton = (e, workLogId, productId) => {
        if (this.handleButton(e)) {
            this.setState({
                confirmModal: {
                    description: gettext("Are you sure you want to add this product to current work group?"),
                    onConfirm: () => this.props.workLogAddProduct(
                        workLogId, productId, this.props.userId, !this.props.isListLayout,
                    ),
                },
            });
        }
    };

    handleStopClicked = (e, activeWorkLogGroup) => {
        e.preventDefault();
        if (this.props.workLogsLoading) {
            return;
        }

        const {userId} = this.props;
        const sameUserWorkLogs = activeWorkLogGroup.work_logs
            .filter(workLog => workLog.user.id === userId);

        if (sameUserWorkLogs.length > 1) {
            this.setState({
                stopConfirmModal: {
                    activeWorkLogGroup,
                },
            });
        } else {
            this.handleActionButton(
                e,
                activeWorkLogGroup.id,
                'stop',
                gettext('Are you sure you want to stop work?'),
            );
        }
    };

    /**
     * Handle case when user chooses to stop all work logs for the given work
     * log group.
     */
    handleStopAllConfirmed = () => {
        const workLogGroup = this.getActiveWorkLog(this.props.activeWorkLogGroups);

        this.props.workLogAction(
            workLogGroup.id,
            'stop',
            this.props.productId,
            this.props.userId,
            !this.props.isListLayout,
        );
    };

    /**
     * Handle case when the user chooses to only stop one product from the work
     * log.
     */
    handleStopOneConfirmed = () => {
        const {productId, userId, activeWorkLogGroups} = this.props;
        const workLogGroup = this.getActiveWorkLog(activeWorkLogGroups);

        this.props.workLogGroupStopOneProduct(workLogGroup.id, productId, userId);
    };

    handleAddUserButton = (e, workLogId) => {
        if (this.handleButton(e)) {
            const userSelect = document.getElementById('user-select');
            if (!userSelect || userSelect.selectedIndex === -1) {
                return;
            }
            const userOption = userSelect.options[userSelect.selectedIndex];
            if (!userOption.value) {
                return;
            }
            this.setState({
                confirmModal: {
                    description: gettext("Are you sure you want to add this worker to current work group?"),
                    onConfirm: () => this.props.workLogAddWorker(workLogId, userOption.value),
                },
            });
        }
    };

    handleStartButton = (e, confirmDescription) => {
        if (this.handleButton(e)) {
            this.setState({
                confirmModal: {
                    description: confirmDescription,
                    onConfirm: () => this.props.workLogStart(
                        this.props.productId, this.props.userId, !this.props.isListLayout,
                    ),
                },
            });
        }
    };

    renderWorkerOption = worker => (
        <option key={worker.id} value={worker.id}>{worker.name}</option>
    );

    renderAddUser = () => {
        if (!this.props.showAddWorker) {
            return null;
        }

        const activeWorkLog = this.getActiveWorkLog(this.props.activeWorkLogGroups);
        if (activeWorkLog === null) {
            return null;
        }

        const activeWorkers = activeWorkLog.work_logs.map(wl => wl.user.id);
        const workers = this.props.workers.filter(w => activeWorkers.indexOf(w.id) === -1);

        if (!workers.length) {
            return null;
        }

        return (
            <div key={`add-user-${this.props.productId}`}>
                <div className="input-group input-group-lg mb-4">
                    <select id="user-select" className="custom-select custom-select-lg">
                        <option value="">{gettext("Select...")}</option>
                        {workers.map(worker => this.renderWorkerOption(worker))}
                    </select>
                    <div className="input-group-append">
                        <button
                            className="btn btn-secondary"
                            onClick={e => this.handleAddUserButton(e, activeWorkLog.id)}
                        >
                            <FontAwesomeIcon icon="user-plus" /> {gettext('Add employee')}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    renderError = () => {
        if (!this.props.workLogsError) {
            return null;
        }
        return (
            <div key={`error-${this.props.productId}`} className="card alert alert-danger" role="alert">
                {this.props.workLogsError}
            </div>
        );
    };

    renderActionButton = (buttonIcon, buttonTitle, buttonAction) => (
        <button
            key={`action-${this.props.productId}`}
            className={this.getButtonClasses(this.props.isListLayout, 'primary')}
            onClick={buttonAction}
        >
            {buttonIcon}
            {!this.props.isListLayout && <span className="mt-1 fs-h5">{buttonTitle}</span>}
        </button>
    );

    renderStopButton = (activeWorkLog) => {
        if (!activeWorkLog.id) {
            return null;
        }
        return (
            <button
                key={`stop-${this.props.productId}`}
                className={this.getButtonClasses(this.props.isListLayout, 'secondary')}
                onClick={(e) => {
                    this.handleStopClicked(e, activeWorkLog);
                }}
            >
                <FontAwesomeIcon icon="check-circle" size={this.getIconSize()} />
                {!this.props.isListLayout && <span className="mt-1 fs-h5">{pgettext("action", "Stop")}</span>}
            </button>
        );
    };

    renderCancelButton = (activeWorkLogId) => {
        if (!activeWorkLogId) {
            return null;
        }
        return (
            <button
                key={`cancel-${this.props.productId}`}
                className={this.getButtonClasses(this.props.isListLayout, 'danger')}
                onClick={e => this.handleActionButton(e, activeWorkLogId, 'cancel',
                    gettext('Are you sure you want to delete work?'))}
            >
                <FontAwesomeIcon icon="times-circle" size={this.getIconSize()} />
                {!this.props.isListLayout && <span className="mt-1 fs-h5">{pgettext("action", "Delete")}</span>}
            </button>
        );
    };

    renderWorkLogsLoading = () => (
        <div
            className={classNames({
                'card px-4 justify-content-center flex-no-grow-fit text-info': this.props.isListLayout,
                'd-flex justify-content-center px-4': !this.props.isListLayout,
            })}
        >
            <FontAwesomeIcon icon="spinner" pulse size="2x" />
        </div>
    );

    renderWorkLogsButtons = () => {
        const activeGroup = this.getActiveWorkLog(this.props.activeWorkLogGroups);

        // Check if product is in progress and current state is not welding.
        // Simultaneous worklogs cannot happen in welding.
        const currentOperation = (this.props.activeWorkLogGroups[0] || {}).operation;
        if (!this.state.InProgressByOtherUser && currentOperation !== ORDERS.STATUS.WELDING) {
            api.productionProductDetail.fetch({pk: this.props.productId}).then(
                (product) => {
                    if (product.active_worklog.in_progress &&
                        !this.props.inProgressForCurrentUser && this.props.userId !== product.active_worklog.user_id) {
                        this.setState({InProgressByOtherUser: true});
                    }
                },
            ).catch(e => console.error(e));
        }

        if (activeGroup && activeGroup.owner.id !== this.props.userId) {
            const fmts = gettext("You are already involved in an active work log group, contact %s.");
            const message = interpolate(fmts, [activeGroup.owner.name]);
            return (
                <div className="card alert alert-info" role="alert">
                    {message}
                </div>
            );
        }

        const isProductWorkLogGroup = !!activeGroup && this.isProductWorkLogGroup(activeGroup, this.props.productId);

        let buttonIcon;
        let buttonTitle;
        let buttonAction;

        if (!this.state.InProgressByOtherUser) {
            if (activeGroup) {
                if (isProductWorkLogGroup) {
                    buttonIcon = <FontAwesomeIcon icon="pause-circle" size={this.getIconSize()} />;
                    buttonTitle = pgettext("action", "Pause");
                    buttonAction = e => this.handleActionButton(e, activeGroup.id, 'pause',
                        gettext('Are you sure you want to pause work?'));
                } else {
                    buttonIcon = <FontAwesomeIcon icon="plus-circle" size={this.getIconSize()} />;
                    buttonTitle = gettext("Add to currently active work log");
                    buttonAction = e => this.handleAddProductButton(e, activeGroup.id, this.props.productId);
                }
            } else if (this.props.workLogGroups.length) {
                buttonTitle = pgettext("action", "Continue");
                buttonIcon = <FontAwesomeIcon icon="play-circle" size={this.getIconSize()} />;
                buttonAction = e => this.handleStartButton(e, gettext("Are you sure you want to continue work?"));
            } else {
                buttonIcon = <FontAwesomeIcon icon="play-circle" size={this.getIconSize()} />;
                buttonTitle = pgettext("action", "Start");
                buttonAction = e => this.handleStartButton(e, gettext("Are you sure you want to start work?"));
            }
        } else {
            return (
                <div className="card alert alert-info" role="alert">
                    {gettext('Product is in progress. Please refresh the page or check later.')}
                </div>
            );
        }
        if (this.props.isListLayout) {
            return ([
                <ConfirmModal key="conf-modal" modal={this.state.confirmModal} onHide={this.hideModal} />,
                <StopConfirmationModal
                    key="stop-conf-modal"
                    onCancel={this.hideStopConfirmModal}
                    isOpen={!!this.state.stopConfirmModal}
                    onConfirmAll={this.handleStopAllConfirmed}
                    onConfirmOne={this.handleStopOneConfirmed}
                />,
                isProductWorkLogGroup ? this.renderAddUser() : null,
                this.renderError(),
                this.renderActionButton(buttonIcon, buttonTitle, buttonAction),
                isProductWorkLogGroup ? this.renderStopButton(activeGroup) : null,
                isProductWorkLogGroup ? this.renderCancelButton(activeGroup.id) : null,
            ]);
        }

        return (
            <div>
                <ConfirmModal modal={this.state.confirmModal} onHide={this.hideModal} />
                <StopConfirmationModal
                    onCancel={this.hideStopConfirmModal}
                    isOpen={!!this.state.stopConfirmModal}
                    onConfirmAll={this.handleStopAllConfirmed}
                    onConfirmOne={this.handleStopOneConfirmed}
                />
                {isProductWorkLogGroup ? this.renderAddUser() : null}
                {this.renderError()}
                <div className="card-deck">
                    {[
                        this.renderActionButton(buttonIcon, buttonTitle, buttonAction),
                        isProductWorkLogGroup ? this.renderStopButton(activeGroup) : null,
                        isProductWorkLogGroup ? this.renderCancelButton(activeGroup.id) : null,
                    ]}
                </div>
            </div>
        );
    };

    render() {
        let content = null;
        if (this.props.workLogsLoading) {
            content = this.renderWorkLogsLoading();
        } else {
            content = this.renderWorkLogsButtons();
        }
        return content;
    }
}

const mapStateToProps = state => ({
    userId: state.workers.worker.id,
});

const mapDispatchToProps = dispatch => ({
    workLogAction: (workLogId, action, productId, userId, fetchProductSpecific) =>
        dispatch(workLogAction(workLogId, action, productId, userId, fetchProductSpecific)),
    workLogAddProduct: (workLogId, productId, userId, fetchProductSpecific) =>
        dispatch(workLogAddProduct(workLogId, productId, userId, fetchProductSpecific)),
    workLogAddWorker: (workLogId, userId) =>
        dispatch(workLogAddWorker(workLogId, userId)),
    workLogStart: (productId, userId, fetchProductSpecific) =>
        dispatch(workLogStart(productId, userId, fetchProductSpecific)),
    workLogGroupStopOneProduct: (workLogGroupId, productId, userId) =>
        dispatch(workLogGroupStopOneProduct(workLogGroupId, productId, userId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProductTimerButtons);



// WEBPACK FOOTER //
// ./src/components/ProductTimerButtons.js